const baseURL = 'https://dev.service.eswhyf.cn/';
// const baseURL = 'https://www.esw235.com/'; //本地测试域名
const openid = '';
const domain = baseURL;
// const domain = 'http://127.0.0.1/';
export default {
    baseURL,
    openid,
    domain
}
